"use client";

import { c as _c } from "react/compiler-runtime";
import "./seo-content.css";
import { type BackendProductsResponse, EventEnum, SortingEnum } from "@sprawdzonabron/shared";
import { Fragment, useEffect, useRef, useState } from "react";
import { TbMapPin2 } from "react-icons/tb";
import { TestIdEnum } from "../../../tests/types";
import { useAnalyticsEvent } from "../../api/hooks/useAnalyticsEvent";
import { selectFilters, useSelector } from "../../store/selectors";
import { useStoreSlices } from "../../store/slices";
import type { ErrorResponse } from "../../types/errors";
import { setUserKnowsAboutShowMapButton } from "../../utils/localStorage";
import { Button } from "../Button/Button";
import { CloseButton } from "../Filters/CloseButton";
import { Sorter } from "../Sorter/Sorter";
import { ChecklistCard } from "./ChecklistCard";
import { ChecklistCardGold } from "./ChecklistCardGold";
import { ErrorMessage } from "./ErrorMessage";
import { ProductItem, ProductItemSkeleton } from "./ProductItem";
import { ChecklistCardEnum } from "./types";
import { getSummaryText } from "./utils";
interface ProductsProps {
  data: BackendProductsResponse;
  hasMore: boolean;
  isLoading: boolean;
  error: ErrorResponse | null;
  loadMore: () => void;
  seoText?: string;
}
export const Products = t0 => {
  const $ = _c(53);
  const {
    data,
    hasMore,
    isLoading,
    error,
    loadMore,
    seoText
  } = t0;
  const lastItemRef = useRef(null);
  const [isSeoContentVisible, setIsSeoContentVisible] = useState(true);
  const [checklistVariant, setChecklistVariant] = useState(ChecklistCardEnum.Default);
  const {
    setFilter
  } = useStoreSlices();
  const filters = useSelector(selectFilters);
  const postSortEvent = useAnalyticsEvent(EventEnum.Sort);
  const {
    setMobileMapVisible
  } = useStoreSlices();
  let t1;
  if ($[0] !== postSortEvent || $[1] !== setFilter) {
    t1 = value => {
      postSortEvent(value);
      setFilter("sorting", value);
    };
    $[0] = postSortEvent;
    $[1] = setFilter;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onChangeSort = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setChecklistVariant(Math.random() > 0.5 ? ChecklistCardEnum.Gold : ChecklistCardEnum.Default);
    };
    t3 = [];
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== hasMore || $[6] !== loadMore) {
    t4 = () => {
      if (!hasMore || !lastItemRef.current) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      }, {
        rootMargin: "200px"
      });
      observer.observe(lastItemRef.current);
      return () => observer.disconnect();
    };
    t5 = [loadMore, hasMore];
    $[5] = hasMore;
    $[6] = loadMore;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  const t6 = data.total;
  let t7;
  if ($[9] !== data.stats.productsByShop) {
    t7 = Object.keys(data.stats.productsByShop);
    $[9] = data.stats.productsByShop;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== data.total || $[12] !== t7.length) {
    t8 = getSummaryText(t6, t7.length);
    $[11] = data.total;
    $[12] = t7.length;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p data-testid={TestIdEnum.ProductsCount} className="text-xs text-slate-500 dark:text-slate-400">{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== filters.sorting || $[17] !== onChangeSort) {
    t10 = <Sorter value={filters.sorting} onChange={onChangeSort} />;
    $[16] = filters.sorting;
    $[17] = onChangeSort;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== setMobileMapVisible) {
    t11 = () => {
      setMobileMapVisible(true);
      setUserKnowsAboutShowMapButton();
    };
    $[19] = setMobileMapVisible;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <TbMapPin2 />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11) {
    t13 = <Button onClick={t11} variant="primary" icon={t12} data-testid={TestIdEnum.ShowMapButton} className="md:hidden" shine={true}>Pokaż mapę</Button>;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t13) {
    t14 = <div className="flex items-center gap-2">{t10}{t13}</div>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t9) {
    t15 = <div className="flex mb-2 items-center justify-between">{t9}{t14}</div>;
    $[27] = t14;
    $[28] = t9;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== data.products.length || $[31] !== error) {
    t16 = data.products.length === 0 && error && <div className="flex flex-col items-center gap-2 w-full mb-2"><ErrorMessage error={error} /></div>;
    $[30] = data.products.length;
    $[31] = error;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== isSeoContentVisible || $[34] !== seoText) {
    t17 = seoText && isSeoContentVisible && <div data-testid={TestIdEnum.ProductsSeoContent} className="bg-white dark:bg-slate-850 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 mb-4 relative"><CloseButton data-testid={TestIdEnum.ProductsSeoContentClose} onClick={() => setIsSeoContentVisible(false)} className="absolute top-2 right-2" /><div className="prose prose-sm dark:prose-invert max-w-none seo-content" dangerouslySetInnerHTML={{
        __html: seoText
      }} /></div>;
    $[33] = isSeoContentVisible;
    $[34] = seoText;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== checklistVariant || $[37] !== data.products || $[38] !== error || $[39] !== hasMore || $[40] !== isLoading || $[41] !== loadMore) {
    t18 = data.products.length > 0 && <div className="flex flex-col gap-4 relative">{data.products.map((product, index) => {
        const isLast = index === data.products.length - 1;
        return <Fragment key={product.url}><ProductItem product={product} ref={isLast && hasMore && !error ? lastItemRef : null} />{index === 6 && (checklistVariant === ChecklistCardEnum.Gold ? <ChecklistCardGold /> : <ChecklistCard />)}</Fragment>;
      })}{isLoading && <ProductItemSkeleton />}{error && <div className="flex flex-col items-center gap-2 w-full"><ErrorMessage error={error} /><Button data-testid={TestIdEnum.ProductsTryAgain} onClick={() => loadMore()}>Spróbuj ponownie</Button></div>}{!hasMore && !error && <div className="flex justify-center p-4 rounded-xl"><p data-testid={TestIdEnum.ProductsAllLoaded} className="text-sm text-slate-500 dark:text-slate-400">Wczytano wszystkie produkty.</p></div>}</div>;
    $[36] = checklistVariant;
    $[37] = data.products;
    $[38] = error;
    $[39] = hasMore;
    $[40] = isLoading;
    $[41] = loadMore;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== data.products.length || $[44] !== error || $[45] !== isLoading) {
    t19 = data.products.length === 0 && !isLoading && !error && <div data-testid={TestIdEnum.ProductsEmpty} className="flex flex-col items-center justify-center py-12 px-4 text-center bg-white dark:bg-slate-850 border border-slate-200 dark:border-slate-800 rounded-2xl"><p className="text-4xl mb-4" aria-label="Tekstowa ikona broni">▄︻デ╦═一━💥</p><p className="text-lg font-medium text-slate-900 dark:text-slate-100 mb-2">Nie znaleźliśmy produktów spełniających kryteria</p><p className="text-slate-500 dark:text-slate-400 max-w-md">Spróbuj zmienić filtry, zwiększyć promień wyszukiwania lub wpisać inną frazę.</p></div>;
    $[43] = data.products.length;
    $[44] = error;
    $[45] = isLoading;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t15 || $[48] !== t16 || $[49] !== t17 || $[50] !== t18 || $[51] !== t19) {
    t20 = <div className="w-full mx-auto">{t15}{t16}{t17}{t18}{t19}</div>;
    $[47] = t15;
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
};